import React from "react";
import DropdownReport from "../../report.dropdwn";
import { GenerateOptionsYear } from "../../../../components/functions/Functions";

const optionsYear = GenerateOptionsYear();

export const optionsMonth = [
  { value: "ALL", label: "ทุกเดือน" },
  { value: "1", label: "มกราคม" },
  { value: "2", label: "กุมภาพันธ์" },
  { value: "3", label: "มีนาคม" },
  { value: "4", label: "เมษายน" },
  { value: "5", label: "พฤษภาคม" },
  { value: "6", label: "มิถุนายน" },
  { value: "7", label: "กรกฎาคม" },
  { value: "8", label: "สิงหาคม" },
  { value: "9", label: "กันยายน" },
  { value: "10", label: "ตุลาคม" },
  { value: "11", label: "พฤศจิกายน" },
  { value: "12", label: "ธันวาคม" },
];

export const optionsType = [
  { value: "NONE", label: "-" },
  { value: "PICC", label: "PICC Line" },
  { value: "CENTRAL_LINE", label: "Central Line" },
];

/**
 * Basic filter with Year and Type
 */
export const FilterYearType = ({ year, setYear, type, setType }) => {
  return (
    <div className="flex space-x-2">
      <DropdownReport
        title={"ปี"}
        options={optionsYear}
        value={year}
        setValue={setYear}
      />
      <DropdownReport
        title={"ประเภทสาย"}
        options={optionsType}
        value={type}
        setValue={setType}
      />
    </div>
  );
};

/**
 * Filter with only Year
 */
export const FilterYearOnly = ({ year, setYear }) => {
  return (
    <div className="flex space-x-2">
      <DropdownReport
        title={"ปี"}
        options={optionsYear}
        value={year}
        setValue={setYear}
      />
    </div>
  );
};

/**
 * Filter with Year, Month and Type
 */
export const FilterYearMonthType = ({
  year,
  setYear,
  month,
  setMonth,
  type,
  setType,
}) => {
  const isMonthDisabled = year.value === "ALL";

  return (
    <div className="flex space-x-2">
      <DropdownReport
        title={"ปี"}
        options={optionsYear}
        value={year}
        setValue={setYear}
        sideFunction={(val) => {
          if (val?.value === "ALL") {
            setMonth({ label: "ทุกเดือน", value: "ALL" });
          }
        }}
      />
      <DropdownReport
        title={"เดือน"}
        options={optionsMonth}
        value={month}
        setValue={setMonth}
        disabled={isMonthDisabled}
      />
      <DropdownReport
        title={"ประเภทสาย"}
        options={optionsType}
        value={type}
        setValue={setType}
      />
    </div>
  );
};

/**
 * Filter with Year and Month only
 */
export const FilterYearMonth = ({ year, setYear, month, setMonth }) => {
  const isMonthDisabled = year.value === "ALL";

  return (
    <div className="flex space-x-2">
      <DropdownReport
        title={"ปี"}
        options={optionsYear}
        value={year}
        setValue={setYear}
        sideFunction={(val) => {
          if (val?.value === "ALL") {
            setMonth({ label: "ทุกเดือน", value: "ALL" });
          }
        }}
      />
      <DropdownReport
        title={"เดือน"}
        options={optionsMonth}
        value={month}
        setValue={setMonth}
        disabled={isMonthDisabled}
      />
    </div>
  );
};

/**
 * Date Range Filter
 */
export const FilterDateRange = ({
  startYear,
  setStartYear,
  endYear,
  setEndYear,
  startMonth,
  setStartMonth,
  endMonth,
  setEndMonth,
}) => {
  const isStartMonthDisabled = startYear.value === "ALL";
  const isEndMonthDisabled = endYear.value === "ALL";

  return (
    <div className="flex flex-wrap justify-end space-x-2">
      <div className="flex space-x-3">
        <DropdownReport
          title={"ปีที่เริ่มต้น"}
          options={optionsYear}
          value={startYear}
          setValue={setStartYear}
          classNameTitle="text-gray-500"
          sideFunction={(val) => {
            if (val?.value === "ALL") {
              setStartMonth({ label: "ทุกเดือน", value: "ALL" });
            }
          }}
        />
        <DropdownReport
          title={"เดือนที่เริ่มต้น"}
          options={optionsMonth}
          value={startMonth}
          setValue={setStartMonth}
          disabled={isStartMonthDisabled}
          classNameTitle="text-gray-500"
        />
      </div>

      <div className="flex space-x-3">
        <DropdownReport
          title={"ปีที่สิ้นสุด"}
          options={optionsYear}
          value={endYear}
          setValue={setEndYear}
          classNameTitle="text-gray-500"
          sideFunction={(val) => {
            if (val?.value === "ALL") {
              setEndMonth({ label: "ทุกเดือน", value: "ALL" });
            }
          }}
        />
        <DropdownReport
          title={"เดือนที่สิ้นสุด"}
          options={optionsMonth}
          value={endMonth}
          setValue={setEndMonth}
          disabled={isEndMonthDisabled}
          classNameTitle="text-gray-500"
        />
      </div>
    </div>
  );
};

export { optionsYear };
